module.exports = __webpack_public_path__ + "img/portraits_18_H.74bee211.webp";